import { Directive, Input, ElementRef, NgZone, Output, EventEmitter, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
class MorrisChartDirective {
    constructor(elementRef, ngZone) {
        this.elementRef = elementRef;
        this.ngZone = ngZone;
        this.window = window;
        this.type = 'Line';
        this.clickChart = new EventEmitter();
    }
    ngOnInit() {
        this._options = Object.assign({}, this.options);
        this._options.element = this.elementRef.nativeElement;
        this._options.data = this.data;
    }
    ngAfterViewInit() {
        if (!this.window.Morris) {
            throw new Error('Please include node_modules/morris.js/morris.js');
        }
        else {
            this.ngZone.runOutsideAngular(() => {
                this.chartInstance = new this.window.Morris[this.type](this._options);
                this.chartInstance.on('click', (i, row) => {
                    this.clickChart.emit({ event, i, row });
                });
            });
        }
    }
    ngOnChanges(changes) {
        if ((changes["data"] && !changes["data"].firstChange) || (changes["options"] && !changes["options"].firstChange)) {
            Object.assign(this.chartInstance.options, this.options);
            this.chartInstance.setData(this.data);
        }
    }
    ngOnDestroy() {
        if (this.chartInstance.el.empty instanceof Function) {
            this.chartInstance.el.empty();
        }
    }
}
MorrisChartDirective.ɵfac = function MorrisChartDirective_Factory(t) { return new (t || MorrisChartDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
MorrisChartDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MorrisChartDirective, selectors: [["", "mk-morris-js", ""]], inputs: { type: "type", options: "options", data: "data" }, outputs: { clickChart: "clickChart" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
MorrisChartDirective.ctorParameters = () => [
    { type: ElementRef, },
    { type: NgZone, },
];
MorrisChartDirective.propDecorators = {
    "type": [{ type: Input },],
    "options": [{ type: Input },],
    "data": [{ type: Input },],
    "clickChart": [{ type: Output },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MorrisChartDirective, [{
        type: Directive,
        args: [{
                selector: '[mk-morris-js]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, { type: [{
            type: Input
        }], clickChart: [{
            type: Output
        }], options: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

class MorrisJsModule {
}
MorrisJsModule.ɵfac = function MorrisJsModule_Factory(t) { return new (t || MorrisJsModule)(); };
MorrisJsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: MorrisJsModule });
MorrisJsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MorrisJsModule, [{
        type: NgModule,
        args: [{
                declarations: [MorrisChartDirective],
                exports: [MorrisChartDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MorrisJsModule, { declarations: [MorrisChartDirective], exports: [MorrisChartDirective] }); })();

export { MorrisChartDirective, MorrisJsModule };

